<template>
  <v-app id="appKontrak" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md8 lg8>
            <v-card class="elevation-1 pa-3 non-printable">
              <v-card-text class="printable wrapper">

                <div class="page">
                  <div class="layout column align-center">
                    <img src="/static/logo-agroforestcape.png" alt="Agroforestcape" width="120" height="120">
                  </div>                

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-2 text-xs-left"><b>Kontrak Pengiriman</b></p>
                      <p class="flex my-1 text-xs-left">{{pergerakanBarangID}}</p>
                      <p class="flex my-1 text-xs-left">{{komoditasPergerakanBarangAktif}}</p>
                      <p class="flex my-1 text-xs-left">&nbsp;</p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-2 text-xs-right"><b>AGROFORESTCAPE</b></p>
                      <p class="flex my-1 text-xs-right">Dramaga, Bogor, Indonesia</p>
                      <p class="flex my-1 text-xs-right">Phone: 082306237345</p>
                      <p class="flex my-1 text-xs-right">Web: agroforestcape.com</p>
                    </div>                
                  </div>

                  <div class="layout column">
                    <p class="flex my-2 text-xs-left">Dokumen ini berisi catatan persetujuan kontrak antara pelanggan dan penyedia pengiriman melalui diskusi antara pengirim yaitu Agroforestcape dengan pelanggan pada tanggal <b>{{komoditasPergerakanBarangAktif}}</b></p>
                    <p class="flex my-2 text-xs-left border">Untuk informasi lebih lanjut, silahkan menghubungi Narahubung Agroforestcape di <b>082306237345</b></p>
                  </div>                

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Pelanggan</b></p>
                      <p class="flex my-1 text-xs-left"><b>{{pembeli}}</b></p>
                      <p class="flex my-2 text-xs-left">Kode Penjualan: <b>{{kodePenjualanPenjemputan}}</b></p>
                      <p class="flex my-1 text-xs-left">Entitas: <b>{{entitasPembeli}}</b></p>
                      <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPembeli}}</b></p>
                      <p class="flex my-1 text-xs-left">Alamat: <b><b>{{alamatJalanPembeli}}, {{alamatKelurahanPembeli}}, {{alamatKecamatanPembeli}}, {{alamatKabupatenPembeli}}, {{alamatProvinsiPembeli}}, {{alamatKodePosPembeli}}</b></b></p>
                      <p v-if="emailPembeli!=='null'" class="flex my-1 text-xs-left">Email: <b>{{emailPembeli}}</b></p>
                      <p v-else class="flex my-1 text-xs-left">Email: <b></b></p>
                      <p v-if="faxPembeli!=='null'" class="flex my-1 text-xs-left">Fax: <b>{{faxPembeli}}</b></p>
                      <p v-else class="flex my-1 text-xs-left">Fax: <b></b></p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Penyedia Pengiriman</b></p>
                      <p class="flex my-1 text-xs-left"><b>{{pengirim}}</b></p>
                      <p class="flex my-2 text-xs-left">Kode Penjualan: <b>{{kodePenjualanPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">Entitas: <b>{{lokasiPenjemputan}}</b></p>
                      <p class="flex my-1 text-xs-left">Kontak: <b>{{kontakPengirim}}</b></p>
                      <p class="flex my-1 text-xs-left">Alamat: <b>{{alamatJalanPenjemputan}}, {{alamatKelurahanPenjemputan}}, {{alamatKecamatanPenjemputan}}, {{alamatKabupatenPenjemputan}}, {{alamatProvinsiPenjemputan}}, {{alamatKodePosPenjemputan}}</b></p>
                      <p v-if="emailPengirim!=='null'" class="flex my-1 text-xs-left">Email: <b>{{emailPengirim}}</b></p>
                      <p v-else class="flex my-1 text-xs-left">Email: <b></b></p>
                      <p v-if="faxPembeli!=='null'" class="flex my-1 text-xs-left">Fax: <b>{{faxPengirim}}</b></p>
                      <p v-else class="flex my-1 text-xs-left">Fax: <b></b></p>
                    </div>                
                  </div>
                </div>

                <div class="page">
                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Komoditas</b></p>
                      <p class="flex my-2 text-xs-left">Tipe Kontrak: <b>{{jenisKontrak}}</b></p>
                      <p class="flex my-1 text-xs-left">Komoditas: <b>{{komoditas}}</b></p>
                      <p class="flex my-1 text-xs-left">Tingkat Kualitas: <b>{{kualitas}}</b></p>
                      <p class="flex my-1 text-xs-left">Kuantitas (<b>{{unitKuantitas}}</b>): <b>{{kuantitas}}</b></p>
                      <p class="flex my-1 text-xs-left">Musim: <b>{{musim}}</b></p>
                      <p class="flex my-1 text-xs-left">Pengiriman Faktur: <b>{{alamatJalanPengiriman}}, {{alamatKelurahanPengiriman}}, {{alamatKecamatanPengiriman}}, {{alamatKabupatenPengiriman}}, {{alamatProvinsiPengiriman}}, {{alamatKodePosPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">Harga: <b>Rp {{formatPrice(hargaKomoditas)}}.00</b></p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Kontrak Pengirim</b></p>
                      <p class="flex my-2 text-xs-left">Faktur: <b>{{faktur}}</b></p>
                      <p class="flex my-1 text-xs-left">Jangka Pembayaran: <b>{{batasTanggalPembayaran}} {{batasWaktuPembayaran}}</b></p>
                      <p class="flex my-1 text-xs-left">Payment Rate: <b>Rp. {{formatPrice(nilaiKomisi)}}.00</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                      <p class="flex my-1 text-xs-left"><b>&nbsp;</b></p>
                    </div>                
                  </div>

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Penjemputan</b></p>
                      <p class="flex my-2 text-xs-left">Tanggal Mulai Penjemputan: <b>{{tanggalMulaiPenjemputan}} {{waktuMulaiPenjemputan}}</b></p>
                      <p class="flex my-1 text-xs-left">Tanggal Berakhir Penjemputan: <b>{{tanggalBerakhirPenjemputan}} {{waktuBerakhirPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">Nama Pengirim: <b>{{pengirim}}</b></p>
                      <p class="flex my-1 text-xs-left">Lokasi Penjemputan: <b>{{lokasiPenjemputan}}</b></p>
                      <p class="flex my-1 text-xs-left">No. Pesanan Penjemputan: <b>{{kodePesananPenjemputanLogistik}}</b></p>
                    </div>                

                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Pengiriman</b></p>
                      <p class="flex my-2 text-xs-left">Tanggal Mulai Pengiriman: <b>{{tanggalMulaiPengiriman}} {{waktuMulaiPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">Tanggal Berakhir Pengiriman: <b>{{tanggalBerakhirPengiriman}} {{waktuBerakhirPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">Nama Penerima: <b>{{penerima}}</b></p>
                      <p class="flex my-1 text-xs-left">Lokasi Pengiriman: <b>{{lokasiPengiriman}}</b></p>
                      <p class="flex my-1 text-xs-left">No. Pesanan Pengiriman: <b>{{kodePesananPengirimanLogistik}}</b></p>
                    </div>                
                  </div>

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Instruksi Penjemputan Khusus</b></p>
                      <p v-if="instruksiKhususPenjemputan" class="flex my-2 text-xs-left">{{instruksiKhususPenjemputan}}</p>
                      <p v-else class="flex my-2 text-xs-left">-</p>
                    </div>                
                  </div>

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Instruksi Pengiriman Khusus</b></p>
                      <p v-if="instruksiKhususPengiriman" class="flex my-2 text-xs-left">{{instruksiKhususPengiriman}}</p>
                      <p v-else class="flex my-2 text-xs-left">-</p>
                    </div>                
                  </div>

                  <div class="layout row border">
                    <div class="layout column">
                      <p class="flex my-1 text-xs-left"><b>Perhatian Khusus</b></p>
                      <p class="flex my-2 text-xs-left">Pihak pengirim disini mengikat pada Agroforestcape beserta syarat dan ketentuan secara lengkap. Silahkan menghubungi pihak Agroforestcape ketika Anda membutuhkan salinan dokumen. Kontrak ini akan menggabungkan peraturan perdagangan Republik Indonesia dan ketentuan penyelesaian permasalahan berlaku sejak dimulainya arbitrasi. Setiap perselisihan, kontroversi dan klaim yang muncul dari kontrak ini, termasuk pertanyaan mengenai eksistensi, validitas atau terminasi, harus diselesaikan dengan arbitrasi sesuai dengan ketentuan penyelesaian permasalahan perdagangan Republik Indonesia pada saat terjadi arbitrasi.</p>
                      <p class="flex my-1 text-xs-left">Merujuk pada <b>http://www.kemendag.go.id/</b></p>
                    </div>                
                  </div>
                </div>

              </v-card-text>

              <v-card-actions>
                <v-btn block color="primary" @click="print" :loading="loading">Print</v-btn>
                <v-btn block color="success" @click="submit" :loading="loading">Submit</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import {HTTP} from '../../http-common';
import moment from 'moment'

export default {
  data: () => ({
    loading: false,

    // Bagian Umum 
    kodePenjualan: localStorage.kontrakKodePenjualan,
    komoditas: localStorage.kontrakKomoditas,
    dokumen: localStorage.kontrakDokumen,

    // Pelaku Usaha
    penjual: localStorage.kontrakPenjual,
    entitasPenjual: localStorage.kontrakEntitasPenjual,
    kontakPenjual: localStorage.kontrakKontakPenjual,
    emailPenjual: localStorage.kontrakEmailPenjual,
    faxPenjual: localStorage.kontrakFaxPenjual,
    alamatJalanPenjual: localStorage.kontrakAlamatJalanPenjual,
    alamatKelurahanPenjual: localStorage.kontrakAlamatKelurahanPenjual,
    alamatKecamatanPenjual: localStorage.kontrakAlamatKecamatanPenjual,
    alamatKabupatenPenjual: localStorage.kontrakAlamatKabupatenPenjual,
    alamatKotaPenjual: localStorage.kontrakAlamatKotaPenjual,
    alamatProvinsiPenjual: localStorage.kontrakAlamatProvinsiPenjual,
    alamatKodePosPenjual: localStorage.kontrakAlamatKodePosPenjual,

    pembeli: localStorage.kontrakPembeli,
    entitasPembeli: localStorage.kontrakEntitasPembeli,
    kontakPembeli: localStorage.kontrakKontakPembeli,
    emailPembeli: localStorage.kontrakEmailPembeli,
    faxPembeli: localStorage.kontrakFaxPembeli,
    alamatJalanPembeli: localStorage.kontrakAlamatJalanPembeli,
    alamatKelurahanPembeli: localStorage.kontrakAlamatKelurahanPembeli,
    alamatKecamatanPembeli: localStorage.kontrakAlamatKecamatanPembeli,
    alamatKabupatenPembeli: localStorage.kontrakAlamatKabupatenPembeli,
    alamatKotaPembeli: localStorage.kontrakAlamatKotaPembeli,
    alamatProvinsiPembeli: localStorage.kontrakAlamatProvinsiPembeli,
    alamatKodePosPembeli: localStorage.kontrakAlamatKodePosPembeli,

    // Penjelasan Kontrak
    jenisKontrak: localStorage.kontrakJenisKontrak,
    kuantitas: localStorage.kontrakKuantitas,
    unitKuantitas: localStorage.kontrakUnitKuantitas,
    kualitas: localStorage.kontrakKualitas,
    hargaKomoditas: localStorage.kontrakHargaKomoditas,
    tempatPembayaran: localStorage.kontrakTempatPembayaran,
    musim: localStorage.kontrakMusim,
    jalurPengiriman: localStorage.kontrakJalurPengiriman,
    skalaPembayaran: localStorage.kontrakSkalaPembayaran,
    batasTanggalPembayaran: localStorage.kontrakBatasTanggalPembayaran,
    batasWaktuPembayaran: localStorage.kontrakBatasWaktuPembayaran,
    toleransi: localStorage.kontrakToleransi,
    daerahPemasaran: localStorage.kontrakDaerahPemasaran,
    provinsiPemasaran: localStorage.kontrakProvinsiPemasaran, 

    // Rincian Pengiriman
    pengirim: localStorage.kontrakPengirim,
    kontakPengirim: localStorage.kontrakKontakPengirim,
    lokasiPenjemputan: localStorage.kontrakLokasiPenjemputan,
    alamatJalanPenjemputan: localStorage.kontrakAlamatJalanPenjemputan,
    alamatKelurahanPenjemputan: localStorage.kontrakAlamatKelurahanPenjemputan,
    alamatKecamatanPenjemputan: localStorage.kontrakAlamatKecamatanPenjemputan,
    alamatKabupatenPenjemputan: localStorage.kontrakAlamatKabupatenPenjemputan,
    alamatKotaPenjemputan: localStorage.kontrakAlamatKotaPenjemputan,
    alamatProvinsiPenjemputan: localStorage.kontrakAlamatProvinsiPenjemputan,
    alamatKodePosPenjemputan: localStorage.kontrakAlamatKodePosPenjemputan,

    penerima: localStorage.kontrakPenerima,
    kontakPenerima: localStorage.kontrakKontakPenerima,
    lokasiPengiriman: localStorage.kontrakLokasiPengiriman,
    alamatJalanPengiriman: localStorage.kontrakAlamatJalanPengiriman,
    alamatKelurahanPengiriman: localStorage.kontrakAlamatKelurahanPengiriman,
    alamatKecamatanPengiriman: localStorage.kontrakAlamatKecamatanPengiriman,
    alamatKabupatenPengiriman: localStorage.kontrakAlamatKabupatenPengiriman,
    alamatKotaPengiriman: localStorage.kontrakAlamatKotaPengiriman,
    alamatProvinsiPengiriman: localStorage.kontrakAlamatProvinsiPengiriman,  
    alamatKodePosPengiriman: localStorage.kontrakAlamatKodePosPengiriman,

    // Detail Pengiriman
    tanggalMulaiPengiriman: localStorage.kontrakTanggalMulaiPengiriman,
    waktuMulaiPengiriman: localStorage.kontrakWaktuMulaiPengiriman,
    tanggalBerakhirPengiriman: localStorage.kontrakTanggalBerakhirPengiriman,
    waktuBerakhirPengiriman: localStorage.kontrakWaktuBerakhirPengiriman,

    // Penjelasan Barang
    jenisPengepakan: localStorage.kontrakJenisPengepakan,

    // Kondisi Kontrak
    kondisiUmum: localStorage.kontrakKondisiUmum,
    kondisiKhusus: localStorage.kontrakKondisiKhusus,

    // Penilaian Kontrak
    nilai: localStorage.kontrakNilai,
    maxNilai: localStorage.kontrakMaxNilai,
    tanggalJatuhTempo: localStorage.kontrakTanggalJatuhTempo,
    waktuJatuhTempo: localStorage.kontrakWaktuJatuhTempo,

    // Usaha Pedagang Perantara
    jenisPembayaran: localStorage.kontrakJenisPembayaran,

    // Administrasi
    invoicing: localStorage.kontrakInvoicing,
    perantara: localStorage.kontrakPerantara,
    entitasPerantara: localStorage.kontrakEntitasPerantara,
    kontakPerantara: localStorage.kontrakKontakPerantara,
    catatanPedagang: localStorage.kontrakCatatanPedagang,

    // Sistem
    kontrakAktif: localStorage.kontrakActiveCurrentDate,
    kontrakId: localStorage.kontrakID,
    komoditasPesananPengirimanStatus: localStorage.komoditasPesananPengiriman,  
    komoditasPesananPengirimanAktif: localStorage.komoditasPesananPengirimanAktif,
    komoditasPesananPengirimanID: localStorage.komoditasPesananPengirimanID,
    komoditasStatusPedagangPerantara: localStorage.komoditasPesananPedagangPerantara,
    komoditasStatusPesananLogistik: localStorage.komoditasPesananLogistik,
    komoditasPergerakanBarangAktif: localStorage.komoditasPergerakanBarangAktif,
    komoditasPesananLogistik: localStorage.komoditasPesananLogistik,
    pergerakanBarangID: localStorage.pergerakanBarangID,

    // Komoditas
    jenisPengirimanPesanan: localStorage.komoditasJenisPengirimanPesanan,
    penyediaJasaPengiriman: localStorage.komoditasPenyediaJasaPengiriman,
    kontakPenyediaJasaPengiriman: localStorage.komoditasKontakPenyediaJasaPengiriman,
    tanggalMulaiPenjemputan: localStorage.komoditasTanggalMulaiPenjemputan,
    waktuMulaiPenjemputan: localStorage.komoditasWaktuMulaiPenjemputan,
    kodePenjualanPenjemputan: localStorage.komoditasKodePenjualanPenjemputan,
    kodePenjualanPengiriman: localStorage.komoditasKodePenjualanPengiriman,
    faktur: localStorage.komoditasFaktur,
    jarakTempuh: localStorage.komoditasJarakTempuh,
    waktuTempuh: localStorage.komoditasWaktuTempuh,
    nilaiKomisi: localStorage.komoditasNilaiKomisi,
      
    // Pergerakan Barang
    statusPergerakanBarang: localStorage.pergerakanBarangStatus,
    kendaraanAngkut: localStorage.pergerakanBarangKendaraanAngkut,
    kodePesananPenjemputanLogistik: localStorage.pergerakanBarangKodePesananPenjemputanLogistik,
    instruksiKhususPenjemputan: localStorage.pergerakanBarangInstruksiKhususPenjemputan,
    kodePesananPengirimanLogistik: localStorage.pergerakanBarangKodePesananPengirimanLogistik,
    instruksiKhususPengiriman: localStorage.pergerakanBarangInstruksiKhususPengiriman,

  }),

  methods: {
    print(){
      window.print();
    },

    submit () {
      localStorage.komoditasPergerakanBarangAktif = moment().format('DD-MM-YYYY');
      localStorage.komoditasPesananPedagangPerantara = 'true';
      window.getApp.$emit('APP_KOMODITAS_LOGISTIK_SUCCESS');
    },

    formatPrice(value) {
        let val = (value/1)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

  }

};
</script>
<style scoped lang="css">
  #appKontrak{
    font-size: 1.1em;
  }

  #login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
  }

  h2{
    text-align: center;
  }

  .border{
    border-bottom: 1px solid;
  }

  #page-break{
    page-break-after: always;
  }

  @media all{
    .break-after {
        display: none;
    }

  }

  @media print{
    #appKontrak{
      width: 100%;
      height:100%;
      position:absolute;
      top:0px;
      bottom:0px;
      margin: auto;
      margin-top: 0px !important;
      /* border: 1px solid; */
    }

    .non-printable {
      visibility: hidden;
    }

    .printable {
      visibility: visible;
    }

    .break-after {
        display: block;
        page-break-after: always;
        position: relative;
    }

    div.page {
      page-break-after: always;
      page-break-inside: avoid;
    }
  }
</style>
